(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var toggle = document.getElementById('filter-toggle-btn');
    var filters = document.querySelector('[data-filters]');
    if (toggle && filters) {
      toggle.addEventListener('click', function(e) {
        e.preventDefault();
        filters.classList.toggle('is-active');
        toggle.classList.toggle('is-active');
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    /* ── Mobile nav + search (existing) ── */
    const t = document.querySelector('[data-mobile-toggle]'), n = document.querySelector('[data-mobile-nav]'), c = document.querySelector('[data-mobile-close]'), o = document.querySelector('[data-overlay]');
    const st = document.querySelector('[data-search-toggle]'), so = document.querySelector('[data-search-overlay]'), sc = document.querySelector('[data-search-close]');
    if(t&&n&&o){
      const open=function(){n.classList.add('is-active');o.classList.add('is-active');document.body.style.overflow='hidden';t.setAttribute('aria-expanded','true');n.setAttribute('aria-hidden','false');o.setAttribute('aria-hidden','false')};
      const close=function(){n.classList.remove('is-active');o.classList.remove('is-active');document.body.style.overflow='';t.setAttribute('aria-expanded','false');n.setAttribute('aria-hidden','true');o.setAttribute('aria-hidden','true')};
      t.addEventListener('click',function(){if(n.classList.contains('is-active')){close()}else{open()}});
      c?.addEventListener('click',close);
      o.addEventListener('click',close);
      document.addEventListener('keydown',function(e){if(e.key==='Escape'&&n.classList.contains('is-active')){close()}});
    }
    if(st&&so&&sc){st.addEventListener('click',()=>{so.classList.add('is-active');so.querySelector('input')?.focus()});sc.addEventListener('click',()=>{so.classList.remove('is-active')})}

    /* ── Theme toggle (auto → light → dark) ── */
    const modes = ['auto', 'light', 'dark'];
    let pref = localStorage.getItem('theme-preference') || 'auto';
    if (!modes.includes(pref)) pref = 'auto';

    function resolvedTheme(mode) {
      if (mode === 'dark') return 'dark';
      if (mode === 'light') return 'light';
      return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    }

    function applyTheme(mode) {
      document.documentElement.setAttribute('data-theme', resolvedTheme(mode));
      /* Update every toggle icon on the page */
      document.querySelectorAll('[data-theme-toggle]').forEach(function(btn) {
        btn.querySelectorAll('svg').forEach(function(svg) {
          svg.classList.toggle('is-visible', svg.dataset.icon === iconForMode(mode));
        });
      });
    }

    function iconForMode(mode) {
      if (mode === 'light') return 'sun';
      if (mode === 'dark') return 'moon';
      return 'auto';
    }

    /* Apply on load */
    applyTheme(pref);

    /* Toggle on click */
    document.querySelectorAll('[data-theme-toggle]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        pref = modes[(modes.indexOf(pref) + 1) % modes.length];
        localStorage.setItem('theme-preference', pref);
        applyTheme(pref);
      });
    });

    /* Listen for OS changes when in auto mode */
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', function() {
      if (pref === 'auto') applyTheme('auto');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('[data-thumb]').forEach(t => {
      t.addEventListener('click', function() {
        document.querySelectorAll('[data-thumb]').forEach(x => x.classList.remove('is-active'));
        this.classList.add('is-active');
        const main = document.getElementById('pdp-main');
        if(main) main.src = this.dataset.src;
      });
    });
    const qi = document.querySelector('[data-qty-input]');
    document.querySelector('[data-qty-minus]')?.addEventListener('click', () => { if(qi && qi.value > 1) qi.value = parseInt(qi.value) - 1; });
    document.querySelector('[data-qty-plus]')?.addEventListener('click', () => { if(qi) qi.value = parseInt(qi.value) + 1; });
    document.querySelectorAll('[data-desc-toggle]').forEach(t => {
      t.addEventListener('click', function() {
        this.classList.toggle('is-active');
        const body = this.nextElementSibling;
        if(body) body.style.display = body.style.display === 'none' ? 'block' : 'none';
      });
    });

    /* ── AJAX Add to Cart ── */
    const productForm = document.querySelector('.pdp form[action*="/cart"]');
    if (productForm) {
      productForm.addEventListener('submit', function(e) {
        e.preventDefault();
        const btn = productForm.querySelector('[type="submit"]');
        const btnText = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Se adauga...';

        const formData = new FormData(productForm);
        // Remove the checkout key if present — we only want add-to-cart
        formData.delete('checkout');

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(function(r) { return r.json(); })
        .then(function() {
          // Fetch full cart to render drawer
          return fetch('/cart.js').then(function(r) { return r.json(); });
        })
        .then(function(cart) {
          if (window.CartDrawer) {
            window.CartDrawer.render(cart);
            window.CartDrawer.updateBadge(cart.item_count);
            window.CartDrawer.open();
          }
        })
        .catch(function(err) {
          console.error('Add to cart error:', err);
        })
        .finally(function() {
          btn.disabled = false;
          btn.textContent = btnText;
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
